import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProjectDetails from "./components/Dashboard/ProjectDetails";
import Tasks from "./pages/Tasks";
import UserProfile from "./pages/UserProfile";
import Sidebar from "./components/Dashboard/Sidebar";
import ReportsPage from "./pages/ReportsPage";
import ProjectsPage from "./pages/ProjectPage";
import TasksPage from "./pages/TasksPage";
import NotificationsPage from "./pages/NotificationsPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { NotificationProvider } from "./components/Notifications/NotificationContext";
import AdminUsersPage from "./pages/AdminUsersPage";
import { refreshUserIfExpired } from "./utils/refreshUser";

function Layout({ children }) {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1 p-3">{children}</div>
    </div>
  );
}

function App() {
  // const [user, setUser] = useState(null);

  // useEffect(() => {
  //   const checkUser = async () => {
  //     const currentUser = await refreshUserIfExpired();
  //     setUser(currentUser);
  //   };

  //   checkUser();
  // }, []);

  return (
    <NotificationProvider>
      <Router>
        <ToastContainer position="bottom-right" autoClose={3000} />
        <Routes>
          {/* Public routes (no sidebar) */}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected/layout routes (with sidebar) */}
          <Route
            path="/dashboard"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="/projects/:id"
            element={
              <Layout>
                <ProjectDetails />
              </Layout>
            }
          />
          <Route
            path="/tasks/:taskId"
            element={
              <Layout>
                <Tasks />
              </Layout>
            }
          />
          <Route
            path="/profile"
            element={
              <Layout>
                <UserProfile />
              </Layout>
            }
          />
          <Route
            path="/reports"
            element={
              <Layout>
                <ReportsPage />
              </Layout>
            }
          />
          <Route
            path="/projects"
            element={
              <Layout>
                <ProjectsPage />
              </Layout>
            }
          />
          <Route
            path="/tasks"
            element={
              <Layout>
                <TasksPage />
              </Layout>
            }
          />
          <Route
            path="/notifications"
            element={
              <Layout>
                <NotificationsPage />
              </Layout>
            }
          />
          <Route
            path="/admin/users"
            element={
              <Layout>
                {JSON.parse(localStorage.getItem("user"))?.role === "Admin" ? (
                  <AdminUsersPage />
                ) : (
                  <Navigate to="/dashboard" />
                )}
              </Layout>
            }
          />
        </Routes>
      </Router>
    </NotificationProvider>
  );
}

export default App;
